/**
 * Custom React hook for using analytics in components
 */
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnalyticsContext } from './provider';

// Create a fallback analytics context that silently ignores all operations
const noopAnalytics = {
  track: () => {},
  trackEvent: () => {},
  identify: () => {},
  page: () => {},
  reset: () => {},
  enabled: false,
  setEnabled: () => {},
  events: {} as any,
};

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  const location = useLocation();

  // Return a noop implementation if the context is missing
  // instead of throwing an error and breaking the app
  if (!context) {
    console.debug('Analytics context not found, using noop implementation');
    return noopAnalytics;
  }

  // Automatically track page views when route changes
  useEffect(() => {
    try {
      if (context.enabled) {
        const pathname = location.pathname;
        const pageName = pathname === '/' ? 'home' : pathname.substring(1).replace(/\//g, '_');

        context.page(pageName, {
          path: pathname,
          url: window.location.href,
          referrer: document.referrer,
        });
      }
    } catch (error) {
      console.debug('Error tracking page view:', error);
    }
  }, [location, context]);

  return context;
};